import * as React from 'react';
import type { SVGProps } from 'react';
const NoTopics = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="261"
    height="190"
    viewBox="0 0 261 190"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="135" cy="95" r="73" fill="#F5F8FA" />
    <rect
      x="28.3344"
      y="46.3344"
      width="213.331"
      height="96.3313"
      rx="3.66563"
      fill="white"
    />
    <rect
      x="28.3344"
      y="46.3344"
      width="213.331"
      height="96.3313"
      rx="3.66563"
      stroke="#E5E9F0"
      strokeWidth="0.66875"
    />
    <g opacity="0.2">
      <rect
        x="33"
        y="55"
        width="204"
        height="17"
        rx="1"
        fill="url(#paint0_linear_9964_9142)"
      />
    </g>
    <rect
      y="76"
      width="204"
      height="17"
      rx="1"
      fill="url(#paint1_linear_9964_9142)"
    />
    <rect
      x="57"
      y="97"
      width="204"
      height="17"
      rx="1"
      fill="url(#paint2_linear_9964_9142)"
    />
    <rect
      x="14"
      y="118"
      width="204"
      height="17"
      rx="1"
      fill="url(#paint3_linear_9964_9142)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_9964_9142"
        x1="33"
        y1="72"
        x2="38.1934"
        y2="12.9203"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C4CEF9" />
        <stop offset="0.817708" stopColor="#7D81C3" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_9964_9142"
        x1="1.77902e-06"
        y1="93"
        x2="5.19338"
        y2="33.9203"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C4CEF9" />
        <stop offset="0.817708" stopColor="#7D81C3" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_9964_9142"
        x1="57"
        y1="114"
        x2="62.1934"
        y2="54.9203"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C4CEF9" />
        <stop offset="0.817708" stopColor="#7D81C3" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_9964_9142"
        x1="14"
        y1="135"
        x2="19.1934"
        y2="75.9203"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C4CEF9" />
        <stop offset="0.817708" stopColor="#7D81C3" />
      </linearGradient>
    </defs>
  </svg>
);

export default NoTopics;
